import { Alert, Card, CardContent, Typography } from '@mui/material';
import StrategyTableView from '../components/StrategyTableView';
import { STRATEGY_STATUS_DRAFT } from './AppConstants';
import type { components as DmsmComponents } from '../types/apis/dmsm/schema-typescript';

type DMSMStrategy = DmsmComponents['schemas']['DMSMStrategy'];
type DMSMStrategyDTO = DmsmComponents['schemas']['DMSMStrategyDTO'];

interface DuplicateStrategyCommonProps {
  setStatusErrorMsg: (msg: string, error?: unknown) => void;
  incrementAPIInProgress: () => void;
  decrementAPIInProgress: () => void;
}

interface DuplicateStrategyAlertProps {
  okToPublish?: boolean;
  duplicateStrategyList?: DMSMStrategyDTO[] | null;
  strategyInformation?: Pick<DMSMStrategy, 'status'> | null;
  commonProps: DuplicateStrategyCommonProps;
}

export default function DuplicateStrategyAlert({
  okToPublish,
  duplicateStrategyList,
  strategyInformation,
  commonProps
}: DuplicateStrategyAlertProps) {
  if (!duplicateStrategyList || duplicateStrategyList.length === 0) return null;

  return (
    <Card>
      <CardContent>
        <Alert
          severity={okToPublish ? 'warning' : 'error'}
          variant={'standard'}
        >
          <Typography fontWeight="bold">
            Conflicting Strategy Exists.
          </Typography>{' '}
          An active strategy exists with the same MGC & Scope.
          {STRATEGY_STATUS_DRAFT === strategyInformation?.status
            ? ' This strategy can exist as a draft but cannot be published '
            : ' This strategy cannot be saved '}
          until the conflict is resolved. See below table for more information
          on strategies that conflict with this one
        </Alert>
        <StrategyTableView
          strategyList={duplicateStrategyList}
          commonProps={commonProps}
        />
      </CardContent>
    </Card>
  );
}
